module.exports = __webpack_public_path__ + "img/wipes.ebdd7615.png";